

module.exports = {
	errorCodes : Object.freeze({
		noCardInReader : 2000,
		communicationError : 2001,
		parsingError : 2002,
		timeout : 2003,
		userCancelled : 2004,
		operationAborted : 2005,
		
		wrongPinTwoTriesLeft : 2100,
		wrongPinOneTryLeft : 2101,
		wrongPinCardBlocked : 2102
	}),
	statusCodes : Object.freeze({
		ok : 0,
		serviceNotRunning : 1,
		internalServiceError : 2,
		serviceOutOfDate : 3,
		extensionNotInstalled : 4,
		nativeAppNotInstalled : 5
	})
};